import { render, staticRenderFns } from "./PermissionIcon.vue?vue&type=template&id=29c60717"
import script from "./PermissionIcon.vue?vue&type=script&lang=js"
export * from "./PermissionIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports